import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/logo1.png";

const mainNav = [
  { display: "HOME", path: "/" },
  { display: "POSTS", path: "/posts" },
  { display: "LISTS", path: "/lists" },
  { display: "REVIEWS", path: "/reviews" },
];

const Header = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const MOBILE_BREAKPOINT = 800;

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setMenuOpen(false);
    }
  }, [isMobile]);

  const isGreenHeader =
    pathname !== "/" && pathname !== "/lists" && pathname !== "/reviews";

  return (
    <div className={`header ${isGreenHeader ? "header-active" : ""}`}>
      <div className={`container ${isGreenHeader ? "container-active" : ""}`}>
        <div className="header_logo">
          <Link to="/">
            <img className="logo_img" src={logo} alt="Logo" />
          </Link>
        </div>

        {/* Hamburger Button */}
        {isMobile && (
          <div
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((p) => !p)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}

        {isMobile && menuOpen && (
          <>
            <div className="menu-overlay" onClick={() => setMenuOpen(false)} />

            <button
              className="overlay-close"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              ✕
            </button>
          </>
        )}

        {/* Menu */}
        {!isMobile && (
          <div className="header_menu desktop-menu">
            {mainNav.map((item) => (
              <div className="header_menu_item" key={item.path}>
                <Link to={item.path}>
                  <span className={pathname === item.path ? "nav-active" : ""}>
                    {item.display}
                  </span>
                </Link>
              </div>
            ))}
          </div>
        )}

        {isMobile && (
          <div
            className={`header_menu mobile-menu ${menuOpen ? "menu-open" : ""}`}
          >
            {mainNav.map((item) => (
              <div className="header_menu_item" key={item.path}>
                <Link to={item.path} onClick={() => setMenuOpen(false)}>
                  <span className={pathname === item.path ? "nav-active" : ""}>
                    {item.display}
                  </span>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
